import { WidgetControlType } from '@examdojo/core/widget';
import type { ArithmeticPreset } from './arithmetic-preset.model';

export const ARITHMETIC_EXPLORATION_PRESET: ArithmeticPreset = {
  id: 'exploration',
  title: 'Exploration Mode',
  description: 'Interactive exploration of arithmetic sequences with slider controls',
  config: {
    id: 'arithmetic-exploration',
    type: 'arithmetic-sequence',
    params: {
      a: 2,
      d: 3,
      numTerms: 6,
    },
    display: {
      grid: false,
      axes: true,
      bars: { enabled: true },
      points: { enabled: true },
      connectingLine: { enabled: true },
      differenceArcs: { enabled: true },
    },
    behavior: {
      features: {
        sliders: false,
        interaction: true,
      },
      controls: [
        {
          id: 'slider-a',
          type: WidgetControlType.Slider,
          label: 'First term a',
          param: 'a',
          position: 'canvas-overlay',
          min: -10,
          max: 20,
          step: 1,
          defaultValue: 2,
          editable: true,
          color: 'pink',
          trigger: { action: 'UPDATE_PARAMS', payload: { param: 'a' } },
        },
        {
          id: 'slider-d',
          type: WidgetControlType.Slider,
          label: 'Common difference d',
          param: 'd',
          position: 'canvas-overlay',
          min: -5,
          max: 10,
          step: 0.5,
          defaultValue: 3,
          editable: true,
          color: 'sky',
          trigger: { action: 'UPDATE_PARAMS', payload: { param: 'd' } },
        },
      ],
    },
  },
};
